import { Injectable } from '@angular/core';
import { Collector } from '@netfoundry-ui/shared/model';
import { ApiService } from '@netfoundry-ui/shared/services';
import { Observable, Subject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { NetflowService } from './netflow.service';

@Injectable({
    providedIn: 'root',
})
export class CollectorService {
    page = null;
    links = null;
    private collectorSource = new Subject<Collector[]>();
    collectors = this.collectorSource.asObservable();
    private apiSub = new Subscription();
    private mapSub = new Subscription();

    constructor(private netflowService: NetflowService, private apiService: ApiService) {}

    /**
     * Gets all Clients for org
     */
    find(params?: any): Observable<any> {
        if (this.apiSub) {
            this.apiSub.unsubscribe();
        }

        if (this.mapSub) {
            this.mapSub.unsubscribe();
        }

        this.mapSub = this.netflowService
            .get('collectors', params)
            .pipe(map(this._extractEmbedded))
            .subscribe((data) => {
                this.page = data['page'];
                this.links = data['links'];
                this.collectorSource.next(data['collectors']);
            });

        // this is an observable that watches for network changes
        return this.collectors;
    }

    get(collectorId) {
        if (this.mapSub) {
            this.mapSub.unsubscribe();
        }

        return this.netflowService.get(`collectors/${collectorId}`);
    }

    /**
     * Saves the mop resource and returns result as observable
     */
    public save(collector: Collector) {
        if (collector.id != null && collector.id !== '') {
            // edit
            return this.netflowService.put(`collectors/${collector.id}`, collector.getSaveObject());
        } else {
            // add
            return this.netflowService.post('collectors', collector.getSaveObject());
        }
    }

    /**
     * Deletes resources against the self link and returns observable result
     */
    public delete(collector: Collector) {
        return this.netflowService.delete(`collectors/${collector.id}`, false);
    }

    /**
     * Preprocesses the data before returning to the front-end
     */
    protected _extractEmbedded(res) {
        const collectors: Collector[] = [];

        if (res['content'] !== undefined) {
            for (let i = 0; i < res['content'].length; i++) {
                const collector = res['content'][i];
                collectors.push(new Collector(collector));
            }
        }

        // object containing information on pagination such as page number, size, total number of items,  and total number of pages
        let page = null;
        if (res['page'] !== undefined) {
            page = res['page'];
        }

        // list of links for jumping to and from pages
        let links = null;
        if (res['_links'] !== undefined) {
            links = res['_links'];
        }

        return { collectors: collectors, page: page, links: links };
    }
}
